$(function ($) {
  $('.home-three .slider-three').slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"></path></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"></path></svg></button>',
    responsive: [{
      breakpoint: 1600,
      settings: {
        slidesToShow: 3
      }
    },{
      breakpoint: 940,
      settings: {
        slidesToShow: 3
      }
    },{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },{
      breakpoint: 568,
      settings: {
        slidesToShow: 2
      }
    }]
  });
  /* BrijeshR 19-10-2021 START */
  $('.col-group-products .slider-three').slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding:'80px',	
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"></path></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"></path></svg></button>',
      responsive: [{
        breakpoint: 1600,
        settings: {
          slidesToShow: 3
        }
      },{
        breakpoint: 940,
        settings: {
          slidesToShow: 2
        }
      },{
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          centerPadding:'40px'
        }
      },{
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          centerPadding:'40px'
        }
      }]
  });
  $('a[href*=\\#]:not([href=\\#])').on('click', function() {
           $('html, body').animate({
            scrollTop: $( $(this).attr('href') ).offset().top - 100
          }, 300);
          return false;
    });
  /* BrijeshR 19-10-2021 END */
  $('.collection-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  }); 
  
  // $('.sliderCarousal').slick({
  //   dots: true,
  //   arrows: true,
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#fff"></path></svg></button>',
  //   nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"></path></svg></button>',
  //   responsive: [{
  //         breakpoint: 1600,
  //         settings: {
  //         slidesToShow: 3
  //         }
  //       },
  //       {
  //           breakpoint: 940,
  //           settings: {
  //           slidesToShow: 3
  //           }
  //       },
  //       {
  //           breakpoint: 767,
  //           settings: {
  //           slidesToShow: 2
  //           }
  //       },
  //       {
  //           breakpoint: 568,
  //           settings: {
  //           slidesToShow: 2
  //           }
  //       }
  //   ]
  // });
  
  
  let spanInterval = setInterval(function(){
	if($('.product-card .product-card__title').length > 0){    
	    clearInterval(spanInterval);
	    equalheight('.product-card .product-card__title');
	    equalheight('.collection_template_main1 .product-card .col-desc');
        equalheight('.collection_template_main .product-card .col-desc');
        equalheight('.info-heding');
        equalheight('.collection_template_main1 .product-card__image-with-placeholder-wrapper');
	}
  }, 500);
 
   
 
  
  if($(window).width() < 768){
    $('.quote-people .slideshow1').slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      verticle:false
    });  
    $('.quote-people .slideshow11').slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      verticle:false
    }); 
    $('ul.slick-dots.show-flex').slick({
      rows: 2,
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2
    }); 
    
  }
  
  $('#QuoteSlideshow1-16148586051e0bb9c7').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    vertical: false,
    verticalSwiping: false,
    adaptiveHeight: true
  });
  
  $('#QuoteSlideshow11-16148586051e0bb9c7').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: true,
    vertical: true,
    verticalSwiping: true,
    adaptiveHeight: true
  });

  /*
  $(document).ready(function(){
    // $fn.scrollSpeed(step, speed, easing);
    jQuery.scrollSpeed(200, 800);
  });

  // Custom scrolling speed with jQuery
  // Source: github.com/ByNathan/jQuery.scrollSpeed
  // Version: 1.0.2

  jQuery.scrollSpeed = function(step, speed, easing) {

    var $document = $(document),
        $window = $(window),
        $body = $('html, body'),
        option = easing || 'default',
        root = 0,
        scroll = false,
        scrollY,
        scrollX,
        view;

    if (window.navigator.msPointerEnabled)

      return false;

    $window.on('mousewheel DOMMouseScroll', function(e) {

      var deltaY = e.originalEvent.wheelDeltaY,
          detail = e.originalEvent.detail;
      scrollY = $document.height() > $window.height();
      scrollX = $document.width() > $window.width();
      scroll = true;

      if (scrollY) {

        view = $window.height();

        if (deltaY < 0 || detail > 0)

          root = (root + view) >= $document.height() ? root : root += step;

        if (deltaY > 0 || detail < 0)

          root = root <= 0 ? 0 : root -= step;

        $body.stop().animate({

          scrollTop: root

        }, speed, option, function() {

          scroll = false;

        });
      }

      if (scrollX) {

        view = $window.width();

        if (deltaY < 0 || detail > 0)

          root = (root + view) >= $document.width() ? root : root += step;

        if (deltaY > 0 || detail < 0)

          root = root <= 0 ? 0 : root -= step;

        $body.stop().animate({

          scrollLeft: root

        }, speed, option, function() {

          scroll = false;

        });
      }

      return false;

    }).on('scroll', function() {

      if (scrollY && !scroll) root = $window.scrollTop();
      if (scrollX && !scroll) root = $window.scrollLeft();

    }).on('resize', function() {

      if (scrollY && !scroll) view = $window.height();
      if (scrollX && !scroll) view = $window.width();

    });       
  };

  jQuery.easing.default = function (x,t,b,c,d) {

    return -c * ((t=t/d-1)*t*t*t - 1) + b;
  };
  */
  $(".colmore").slice(0, 8).show();
  if ($(".colless:hidden").length != 0) {
    $("#loadMore").show();
  }else{
    $('#loadMore').hide();
  }   
  if ($('#loadMore').parent().find(".colmore").length < 8) {
    $('#loadMore').parent().find('#loadMore').hide();
  }
  $("#loadMore a").on('click',function(e){
      e.preventDefault();
    $(this).parent('#loadMore').parent().find(".colmore:hidden").slice(0, 200).slideDown();
     let spanInterval = setInterval(function(){
      if($('.product-card .product-card__title').length > 0){    
        clearInterval(spanInterval);
        equalheight('.product-card .product-card__title');
        equalheight('.collection_template_main1 .product-card .col-desc');
        equalheight('.collection_template_main .product-card .col-desc');
        equalheight('.info-heding');
        equalheight('.collection_template_main1 .product-card__image-with-placeholder-wrapper');
      }
    }, 500);
    var $colmore = $(this).parent('#loadMore').parent().find(".colmore");
     setTimeout(function(){ 
    	$colmore.css("opacity","1");
     }, 500);
    if ($(this).parent('#loadMore').parent().find(".colmore:hidden").length == 0) {
      $(this).parent('#loadMore').fadeOut('slow');
    }
  });
});